type LogoutCallback = () => void;
const logoutCallbacks: LogoutCallback[] = [];

export const authEvents = {
  onLogout: (cb: LogoutCallback) => {
    logoutCallbacks.push(cb);
  },
  triggerLogout: () => {
    logoutCallbacks.forEach((cb) => cb());
  },
};
